export default "__VITE_ASSET__B9iuTY5N__"